
import { Injectable } from '@angular/core';

import { OperationStream } from '../models/operation-stream.model';
import { ConsumerLicenseService, UserLicenses } from './consumer-license.service';

@Injectable()
export class OfficeHomeConsumerLicenseService implements ConsumerLicenseService {

    public getLicenses(): OperationStream<UserLicenses> {
        return null;
    }
}
